import {
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AppIconPaths } from "src/app/shared/common/app-icon.path";
import { UserTypeEnum } from "src/app/shared/common/common.enum";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import {
  NgxCaptchaModule,
  ReCaptcha2Component,
  ReCaptchaV3Service,
} from "ngx-captcha";
import {
  AppRoutePaths,
  AppRoutes,
} from "src/app/shared/common/app-path.routes";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCardModule } from "@angular/material/card";
import { CommonModule } from "@angular/common";
import { MatGridListModule } from "@angular/material/grid-list";
import { AdminService, ApplicationAccess } from "../../../../api/admin.service";
import { catchError, map, Observable, of, switchMap, tap, timer } from "rxjs";
import { UsersService } from "src/app/api/users.service";
import { GlobalServiceService } from "src/app/shared/services/global-service.service";
import { environment } from "src/app/environments/environment.development";
import { InternalUserRegistration } from "src/app/shared/models/user.model";
import {
  ApiResponse,
  AppOption,
} from "src/app/shared/models/registration.models";
import { atLeastOneSelected } from "../../../external-user-registration/registration.validators";
import { Router } from "@angular/router";
import { LoaderService } from "src/app/core/Loader.services";
import { MatDialogRef } from "@angular/material/dialog";
@Component({
  selector: "app-interuser-registration-form",
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatInputModule,
    MatSnackBarModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatGridListModule,
    NgxCaptchaModule,

    // required
    // RecaptchaFormsModule,
  ],
  templateUrl: "./interuser-registration-form.component.html",
  styleUrl: "./interuser-registration-form.component.css",
})
export class InteruserRegistrationFormComponent implements OnInit, OnChanges {
  appIconPaths = AppIconPaths;
  userTypeEnum = UserTypeEnum;
  @Input isCaptchneeded: boolean = false;
  // selectedUserType: UserTypeEnum = UserTypeEnum.internal;
  selectedUserType!: UserTypeEnum;

  userTypeOptions: { label: string; value: string }[] = [
    { label: UserTypeEnum.internal, value: UserTypeEnum.internal },
    { label: UserTypeEnum.external, value: UserTypeEnum.external },
  ];

  // siteKey = ""; // v2 site key
  siteKey = environment.googleCaptchaKey; // v2 site key
  // captchaResolved = false;

  registrationForm!: FormGroup;
  appRoutePaths = AppRoutePaths;
  appRoutes = AppRoutes;

  applicationList!: ApplicationAccess[];
  private loader = inject(LoaderService);
  private dialogRef = inject(MatDialogRef<InteruserRegistrationFormComponent>, {
    optional: true,
  });
  private snack = inject(MatSnackBar);
  loading = false;
  // Optional: access the widget to programmatically reset
  @ViewChild("captchaElem") captchaElem?: ReCaptcha2Component;
  captchaToken: string | null = null;

  // UI helpers
  captchaResolved = false;
  captchaError?: string;
  captchaLoaded = false;
  @Input() capcthaV3Token: string = "";

  licenseMaestroFormUrl = environment.licenseMaestroFormUrl;
  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private userService: UsersService,
    private gbService: GlobalServiceService,
    private router: Router,
    private reCaptchaV3Service: ReCaptchaV3Service,
  ) {
    this.applicationList = this.adminService.applicationList;
  }

  ngOnInit(): void {
    if (this.dialogRef) {
      //this.executeCaptchaV3(this.dialogRef._containerInstance._config.data?.userType || 'internal');
    }
    this.buildForm();
    //his.logInvalidControls();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["capcthaV3Token"]?.previousValue !=
      changes["capcthaV3Token"].currentValue
    ) {
      this.registrationForm.patchValue({ recaptcha: this.capcthaV3Token });
    }
  }

  private buildForm() {
    this.registrationForm = this.fb.group({
      userType: [UserTypeEnum],
      // userId: [
      //   "",
      //   [
      //     Validators.required,
      //     Validators.pattern(REGEX_PATTERN.backSlashValidator),
      //   ],
      // ],
      firstName: ["", [Validators.required, Validators.maxLength(30)]],
      lastName: ["", [Validators.required, Validators.maxLength(30)]],
      email: [
        "",
        {
          validators: [
            Validators.required,
            Validators.email,
            Validators.maxLength(120),
          ],
          // asyncValidators: [emailDuplicateValidator(this.userService)],
          // updateOn: "blur",
        },
      ],
      managerEmail: [
        "",
        [Validators.required, Validators.email, Validators.maxLength(120)],
      ],
      mirrorAccount: [""],
      recaptcha: [
        this.capcthaV3Token,
        [this.isCaptchneeded ? Validators.required : Validators.nullValidator],
      ],
      // appAccess: this.fb.array([]),
      appAccess: this.fb.array(
        [false, false, false, false, false].map((v) => this.fb.control(v)),
        [atLeastOneSelected()],
      ),
    });

    // this.applicationList.forEach((element: ApplicationAccess) => {
    //   const applicationForm = this.fb.group({
    //     applicationId: [element.applicationId],
    //     name: [element.name],
    //     isSelected: [element.isSelected],
    //   });
    //   this.appAccessFA.push(applicationForm);
    // });
  }
  // get appAccess(): FormArray {
  //   return this.registrationForm?.get("appAccess") as FormArray;
  // }

  get appAccessFA(): FormArray {
    return this.registrationForm.get("appAccess") as FormArray;
  }
  // private selectApplication() {
  //   this.appAccess.controls.forEach((group) => {
  //     group
  //       .get("isSelected")
  //       ?.valueChanges.pipe(takeUntil(this.destroy$))
  //       .subscribe(() => {
  //         const id = group.get("applicationId")?.value;
  //         const isSelected = group.get("isSelected")?.value;
  //         //if click on select all
  //         if (id == -1) {
  //           this.appAccess.controls.forEach((group) => {
  //             group
  //               .get("isSelected")
  //               ?.setValue(isSelected, { emitEvent: false });

  //             group.get("isSelected")?.markAsDirty();
  //             group.get("isSelected")?.updateValueAndValidity();
  //           });
  //         }
  //       });
  //   });
  // }

  // called when token expires (user waited too long)
  // onCaptchaExpired() {
  //   this.registrationForm.get("recaptchaToken")?.reset();
  // }

  // optional: handle internal errors
  // onCaptchaError(err: any) {
  //   console.warn("reCAPTCHA error:", err);
  //   this.resetCaptcha();
  // }

  // Called when the Google widget finishes rendering
  handleLoad(): void {
    this.captchaLoaded = true;

    // Optional: inspect rendered widget IDs (v2 checkbox/invisible)
    const ids = (window as any).grecaptcha?.getWidgetsIds
      ? (window as any).grecaptcha.getWidgetsIds()
      : [];

    // Optional: if you render inside a dialog/stepper, ensure it’s visible & give it focus
    setTimeout(() => this.focusCaptchaIframe(), 0);
  }

  // Optional helper: focus the iframe to improve accessibility
  private focusCaptchaIframe(): void {
    try {
      const iframe = document.querySelector<HTMLIFrameElement>(
        'iframe[src*="google.com/recaptcha"]',
      );
      iframe?.focus();
    } catch {
      /* no-op */
    }
  }

  /** Fires when the user successfully solves the captcha; receives a token */
  handleSuccess(token: string): void {
    this.captchaToken = token;
    this.captchaError = undefined;

    // Store token in the reactive form control
    this.registrationForm.patchValue({ recaptcha: token });
  }

  /** Fires when the captcha token expires */
  handleExpire(): void {
    this.captchaToken = "";
    this.captchaError = "Captcha expired. Please try again.";
    this.registrationForm.patchValue({ recaptcha: "" });
  }

  /** Fires when the widget is reset (e.g., programmatically) */
  handleReset(): void {
    this.captchaToken = "";
    this.captchaError = undefined;
    this.registrationForm.patchValue({ recaptcha: "" });
  }

  /** Programmatically reset the captcha (e.g., after a server validation failure) */
  resetCaptcha(): void {
    try {
      this.captchaElem?.resetCaptcha();
    } catch (e) {}
    // Keep local/UI state synced
    this.captchaToken = "";
    this.registrationForm.patchValue({ recaptcha: "" });
  }

  isEmailExistValidator(
    control: AbstractControl,
  ): Observable<ValidationErrors | null> {
    const email = control.value;
    // Skip empty values; let required/pattern validators handle those
    if (email == null || email === "") return of(null); // OK

    // Debounce to avoid hammering the API on each keystroke

    return timer(300).pipe(
      tap(),
      switchMap(() => {
        return this.userService.isEmailTaken(email);
      }),
      tap(),
      map((res) => (res.exists ? { emailExists: true } : null)),
      catchError((err: Error) => {
        return of(null);
      }),
    );

    // return timer(300).pipe(
    //   switchMap(() => this.userService.isEmailTaken(email)),
    //   map((res: { exists: boolean; message?: string }) =>
    //     res.exists ? { emailExists: true } : null
    //   ),
    //   catchError(() => of(null))
    // );
  }

  logInvalidControls() {
    this.registrationForm.markAllAsTouched();
    Object.keys(this.registrationForm.controls).forEach((key) => {
      const control = this.registrationForm.get(key);
      if (control?.invalid) {
        console.log(`:x: Invalid control: ${key}`, {
          value: control.value,
          errors: control.errors,
          touched: control.touched,
          dirty: control.dirty,
        });
      }
    });
  }

  onSubmit() {
    if (this.registrationForm.valid) {
      this.loading = true;
      this.loader.show();
      let CurrentUserId = 0;
      const userIdFromSession = this.userService.getUserIdFromSession();
      CurrentUserId =
        userIdFromSession !== "UserId" ? parseInt(userIdFromSession, 10) : 0;
      const selectedApps = this.getSelectedAppIds();
      const form = { ...this.registrationForm.value };
      const payload: InternalUserRegistration = {
        userId: "NA",
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        managerEmail: form.managerEmail,
        mirrorAccount: form.mirrorAccount,
        applicationIds: selectedApps.join(","),
        ipAddress: "",
        requester_email:
          this.userService.getUserEmailFromSession() || form.email,
        aeMapId: 0,
      };
      try {
        this.userService
          .internalUserRegistration(payload)
          .subscribe((resp: ApiResponse<InternalUserRegistration>) => {
            const successMsg = "Request submitted successfully.";
            if (resp.status) {
              this.snack.open(successMsg, "Close");
              this.onCancel();
            } else {
              const failMsg = resp.message || "Request not submitted.";
              this.snack.open(failMsg, "Close", { duration: 8000 });
            }
          });
      } catch (error) {
        const errMsg = "Request not submitted.";
        this.snack.open(errMsg, "Close", { duration: 8000 });
      } finally {
        this.loading = false;
        this.loader.hide();
      }
    }
  }

  // onCaptchaSuccess(token: string) {
  //   this.captchaResolved = true;
  //   this.form.get("captcha")?.setValue(token);
  // }

  // onCaptchaError(err: any) {
  //   this.captchaResolved = false;
  //   this.form.get("captcha")?.reset();
  //   console.error("Captcha error:", err);
  // }

  onCaptchaReady() {
    // Captcha widget is ready
  }

  get emailTakenInfo(): { exists: boolean; message?: string } | null {
    const err = this.registrationForm.get("email")?.getError("emailTaken");
    return err ? { exists: !!err.exists, message: err.message } : null;
  }

  readonly appKeys = [
    "SalesForce Deal Memo: Contract entry and amendment",
    "Tracker+: Product Development and Tracking",
    "Creative Library: Find, Download, and Share creative digital assets from our library of properties",
    "Financial Center: Royalties, payments, and financials",
    "Salesforce Forecasting: Forecast submissions and adjustment",
  ];

  readonly appOptions: AppOption[] = [
    {
      AppId: "1",
      Key: "SalesForce Deal Memo: Contract entry and amendment",
      label: "SalesForce Deal Memo",
    },
    {
      AppId: "4",
      Key: "Tracker+: Product Development and Tracking",
      label: "Tracker+",
    },
    {
      AppId: "5",
      Key: "Creative Library: Find, Download, and Share creative digital assets from our library of properties",
      label: "Creative Library",
    },
    {
      AppId: "6",
      Key: "Financial Center: Royalties, payments, and financials",
      label: "Financial Center",
    },
    {
      AppId: "7",
      Key: "Salesforce Forecasting: Forecast submissions and adjustment",
      label: "Salesforce Forecasting",
    },
  ];

  // Holds the list to render (derived)
  visibleAppOptions: AppOption[] = [...this.appOptions];
  // Map for quick id → index in master
  // private appIndexById = new Map<string, number>(
  //   this.appOptions.map((opt, i) => [opt.AppId, i])
  // );

  appCheckedChanged(i: number, checked: boolean) {
    this.appAccessFA.at(i).setValue(checked);
    this.appAccessFA.updateValueAndValidity();
  }

  onCancel() {
    //update this methode to close the dialog.
    if (this.dialogRef) {
      this.dialogRef.close({ saved: false });
    } else {
      this.router.navigate([AppRoutePaths[AppRoutes.Login]]);
    }

    //this.router.navigate([AppRoutePaths[AppRoutes.Login]]);
  }

  private getSelectedAppIds(): string[] {
    // Map each checked index to its corresponding option.id
    return this.appOptions
      .map((opt, i) => ({
        id: opt.AppId,
        checked: !!this.appAccessFA.at(i).value,
      }))
      .filter((x) => x.checked)
      .map((x) => x.id);
  }

  executeCaptchaV3(value: string): void {
    if (value.toLowerCase() === this.userTypeEnum.internal.toLowerCase()) {
      this.reCaptchaV3Service.execute(
        this.siteKey,
        this.appRoutes.InternalUserRegistration,
        (token) => {
          if (token) {
            this.registrationForm.patchValue({ recaptcha: token });
          } else {
            this.registrationForm.patchValue({ recaptcha: "" });
          }
        },
        {
          useGlobalDomain: false, // optional
        },
      );
    }
  }
}
